import React from 'react';
import { Clock } from 'lucide-react'; // Optional icon

const TimePickerField = ({ label, mode, value, onChange }) => {
  const isViewOnly = mode === "view";

  const handleTimeChange = (newTime) => {
    if (!newTime) return;
    let [timePart, periodPart] = newTime.split(" ");
    if (!periodPart) periodPart = "AM"; // default AM if missing
    onChange(`${timePart} ${periodPart}`);
  };

  // Split value into time and period for display
  let [time, period] = (value || "12:00 AM").split(" ");

  return (
    <div className="flex flex-col gap-1.5 w-full">
      <label className="text-xs font-bold uppercase tracking-wider text-gray-500 ml-1">
        {label}
      </label>

      <div className={`flex items-stretch transition-all duration-200 rounded-xl overflow-hidden border ${
        isViewOnly 
          ? "bg-gray-50 border-gray-200" 
          : "bg-white border-gray-300 shadow-sm focus-within:border-blue-500 focus-within:ring-4 focus-within:ring-blue-500/10"
      }`}>
        
        <div className="flex items-center pl-3 flex-grow">
          <Clock size={16} className={isViewOnly ? "text-gray-400" : "text-blue-500"} />
          <div className="relative w-full">
            <input
              type="text"
              list={`list-${label.replace(/\s+/g, '')}`}
              value={time}
              onChange={(e) => handleTimeChange(`${e.target.value} ${period}`)}
              disabled={isViewOnly}
              placeholder="12:00"
              className="w-full px-3 py-3 text-sm font-medium bg-transparent outline-none disabled:text-gray-500 placeholder:text-gray-300"
            />
            <datalist id={`list-${label.replace(/\s+/g, '')}`}>
              {Array.from({ length: 12 }, (_, i) => i === 0 ? 12 : i)
                .flatMap(hour => [`${hour}:00`, `${hour}:15`, `${hour}:30`, `${hour}:45`])
                .map((t) => <option key={t} value={t} />)
              }
            </datalist>
          </div>
        </div>

        <div className="flex p-1 bg-gray-100/50 border-l border-gray-200">
          {["AM", "PM"].map((p) => (
            <button
              key={p}
              type="button"
              disabled={isViewOnly}
              onClick={() => handleTimeChange(`${time} ${p}`)}
              className={`px-4 py-1.5 text-[11px] font-black rounded-lg transition-all duration-200 ${
                period === p 
                  ? "bg-white text-blue-600 shadow-sm ring-1 ring-black/5" 
                  : "text-gray-400 hover:text-gray-600"
              } disabled:cursor-not-allowed`}
            >
              {p}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TimePickerField;
